export enum AnchorState {
    None = 'None',
    Inactive = 'Inactive',
    Pending = 'Pending',
    Localized = 'Localized',
    Error = 'Error',
    Edit = 'Edit',
    EditPending = 'EditPending'
}

class MarkerInfo
{
    id: string = '';
    pos: {lat: number, lng: number} = {lat: 0, lng: 0};
    icon: string | undefined;
    title: string | undefined;
    popupInfo: string | undefined;
    state: AnchorState | undefined;// = AnchorState.None;
}

export default MarkerInfo;
